import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2aaba876"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ai-generation-categories-selection"
};
const _hoisted_2 = {
  class: "ai-suggestions-body"
};
const _hoisted_3 = {
  class: "ai-suggestions-bottom"
};
const _hoisted_4 = {
  class: "analyzed-category"
};
const _hoisted_5 = {
  class: "analyzed-category-header"
};
const _hoisted_6 = {
  class: "info-wrapper"
};
const _hoisted_7 = {
  class: "info-title"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex": "1 0 0"
  }
}, "ANALYZED CATEGORY", -1));
const _hoisted_9 = {
  class: "info-subtitle"
};
const _hoisted_10 = {
  class: "analyzed-category-body"
};
const _hoisted_11 = {
  key: 1,
  class: "products"
};
const _hoisted_12 = {
  class: "product-images"
};
const _hoisted_13 = {
  class: "chosen-ai-categories"
};
const _hoisted_14 = {
  class: "most-important"
};
const _hoisted_15 = {
  class: "least-important"
};
const _hoisted_16 = {
  key: 0,
  class: "draggable-wrapper",
  ref: "noCategoriesWrapper"
};
const _hoisted_17 = {
  class: "drag-icon"
};
const _hoisted_18 = {
  style: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    height: 'unset',
    padding: '7px 0px 7px 16px',
    cursor: 'grab'
  },
  class: "draggable-inner"
};
const _hoisted_19 = {
  class: "drag-icon"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_b_spinner = _resolveComponent("b-spinner");
  const _component_category_item_new = _resolveComponent("category-item-new");
  const _component_b_img = _resolveComponent("b-img");
  const _component_draggable = _resolveComponent("draggable");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: _normalizeClass(['ai-suggestions', $options.getClassPerType])
  }, [_createElementVNode("div", {
    class: _normalizeClass(['ai-suggestions-title', $options.getClassPerType])
  }, [_createVNode(_component_app_icon, {
    icon: "annotation-heart",
    color: $props.type == 'product_benefits' ? '#5A52AE' : '#B75B15'
  }, null, 8, ["color"]), _createElementVNode("div", null, [_createTextVNode("OmnyAI analyzed "), _createElementVNode("b", null, _toDisplayString($props.product.review_count), 1), _createTextVNode(" user reviews")])], 2), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    class: _normalizeClass(['add-all-button', $options.getClassPerType])
  }, [_createElementVNode("div", {
    class: _normalizeClass(['add-all-text', $options.getClassPerType]),
    onClick: _cache[0] || (_cache[0] = (...args) => $options.moveAllToActive && $options.moveAllToActive(...args))
  }, " Add all ", 2), _createVNode(_component_app_icon, {
    icon: "arrows-right",
    color: $props.type == 'product_benefits' ? '#5A52AE' : '#B75B15',
    onClick: $options.moveAllToActive
  }, null, 8, ["color", "onClick"])], 2), $data.categories_loading ? (_openBlock(), _createBlock(_component_b_spinner, {
    key: 0,
    style: {
      "align-self": "center"
    }
  })) : (_openBlock(true), _createElementBlock(_Fragment, {
    key: 1
  }, _renderList($data.inactiveCategories, ({
    id,
    category,
    score,
    active,
    custom,
    edit,
    manual
  }, index) => {
    return _openBlock(), _createBlock(_component_category_item_new, {
      key: index,
      id: id,
      category: category,
      score: score,
      active: active,
      custom: custom,
      edit: edit,
      manual: manual,
      type: $props.type,
      onSelectCategory: $options.moveToActiveCategories
    }, null, 8, ["id", "category", "score", "active", "custom", "edit", "manual", "type", "onSelectCategory"]);
  }), 128))]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_app_icon, {
    icon: "dataflow"
  }), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_hoisted_8, _createVNode(_component_app_icon, {
    icon: "info",
    size: "12",
    color: "#ED96BB"
  })]), _createElementVNode("div", _hoisted_9, _toDisplayString($props.product.category_name), 1)])]), _createElementVNode("div", _hoisted_10, [$data.competitors_loading ? (_openBlock(), _createBlock(_component_b_spinner, {
    key: 0
  })) : _createCommentVNode("", true), $data.competitors ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_ctx.index < 3 ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList($data.competitors, (competitor, index) => {
    return _openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_component_b_img, {
      src: competitor.image,
      alt: "Image",
      width: 24,
      height: 24,
      class: "product-image"
    }, null, 8, ["src"])]);
  }), 256)) : _createCommentVNode("", true), _createTextVNode(" + " + _toDisplayString($data.competitors.length - 3) + " products ", 1)])) : _createCommentVNode("", true), _createVNode(_component_app_icon, {
    icon: "link",
    size: "16",
    color: "#E16098",
    style: {
      "cursor": "pointer"
    },
    onClick: $options.categoryRedirect
  }, null, 8, ["onClick"])])])])], 2), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", {
    class: "importance-frame",
    style: _normalizeStyle($options.frameStyle)
  }, [_createElementVNode("div", _hoisted_14, [_createTextVNode(" Most important "), _createVNode(_component_app_icon, {
    icon: "arrow-up",
    size: "12",
    color: "#72BB86"
  })]), _createElementVNode("div", {
    class: "importance-line",
    style: _normalizeStyle($options.lineStyle)
  }, null, 4), _createElementVNode("div", _hoisted_15, [_createTextVNode("Least important "), _createVNode(_component_app_icon, {
    icon: "arrow-down",
    size: "12",
    color: "#B7BDC2"
  })])], 4), !$data.activeCategories.length ? (_openBlock(), _createElementBlock("div", _hoisted_16, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, n => {
    return _createElementVNode("div", {
      key: n,
      class: "draggable-inner",
      style: {
        justifyContent: 'space-between'
      },
      onClick: _cache[1] || (_cache[1] = (...args) => $options.addCategory && $options.addCategory(...args))
    }, [_createTextVNode(" + Add " + _toDisplayString($props.type.split("_")[1]) + " or select AI suggestions ", 1), _createElementVNode("div", _hoisted_17, [_createVNode(_component_app_icon, {
      icon: "alert-octagon"
    })])]);
  }), 64))], 512)) : (_openBlock(), _createBlock(_component_draggable, {
    key: 1,
    ref: "draggableWrapper",
    modelValue: $options.updatedActiveCategories,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $options.updatedActiveCategories = $event),
    class: "draggable-wrapper",
    onStart: _cache[4] || (_cache[4] = $event => _ctx.dragging = true),
    onEnd: _cache[5] || (_cache[5] = $event => _ctx.dragging = false),
    onMove: _ctx.handleDragging
  }, {
    item: _withCtx(({
      element
    }) => [_createElementVNode("div", _hoisted_18, [(_openBlock(), _createBlock(_component_category_item_new, {
      key: element.category,
      id: element.id,
      category: element.category,
      score: element.score,
      active: element.active,
      custom: element.custom,
      edit: element.edit,
      manual: element.manual,
      dragging: _ctx.dragging,
      type: $props.type,
      onSelectCategory: $options.moveToInactiveCategories,
      onEditCategory: $options.editCategory
    }, null, 8, ["id", "category", "score", "active", "custom", "edit", "manual", "dragging", "type", "onSelectCategory", "onEditCategory"])), _createElementVNode("div", {
      class: _normalizeClass(['drag-icon', {
        dragging: _ctx.dragging
      }])
    }, [_createVNode(_component_app_icon, {
      icon: "dragger",
      color: "#616161",
      size: "16"
    })], 2)])]),
    footer: _withCtx(() => [$options.canAddCategory ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "add-category-button",
      style: {
        justifyContent: 'space-between'
      },
      onClick: _cache[2] || (_cache[2] = (...args) => $options.addCategory && $options.addCategory(...args))
    }, [_createTextVNode(_toDisplayString($data.addButtonText[$props.type]) + " ", 1), _createElementVNode("div", _hoisted_19, [_createVNode(_component_app_icon, {
      icon: "alert-octagon"
    })])])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["modelValue", "onMove"]))])]);
}